import {
  type QueryKey,
  type UseSuspenseQueryOptions,
  useSuspenseQuery,
} from "@tanstack/react-query";
import type { ScopedBinding } from "@/app/types";
import { useResourceScope } from "@/lib/resource-context";
import type { ToolResponse } from "../types";
import { toolsQueryOptions } from "./get-tools";

type UseGetToolsOptions = Omit<
  UseSuspenseQueryOptions<ToolResponse, Error, ToolResponse, QueryKey>,
  "queryKey" | "queryFn"
> & {
  userId?: string;
};

export const useGetTools = (
  binding: ScopedBinding = "project",
  options?: UseGetToolsOptions
) => {
  const scope = useResourceScope();
  const { userId, ...queryOptions } = options ?? {};

  return useSuspenseQuery({
    ...toolsQueryOptions({ binding, scope, userId }),
    ...queryOptions,
  });
};
